const GROUPS = {
    hotspot: [ "全部", "超链接", "电话", "图文", "文本", "视频", "场景切换", "文章", "音乐", "餐饮", "导航", "服装", "工业", "家居", "人物", "商业", "医疗", "运动", "3D", "其他" ],
    panospot: [ "全部" ],
}

const ICONS = {
    ///////////////////////////////////////////////////////////
    //热点图标
    hotspot: [         
		[],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "2_24", "3_24", "4_24", "5_24" ],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "2_24" ],
        [ "1", "2", "3", "4", "5" ],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "2_24" ],
        [ "1", "2", "3", "4", "5", "6", "1_24" ],
        [ "1", "2", "3", "4", "5", "6", "7", "1_24", "2_24", "3_24", "4_24", "5_24", "6_24", "7_24", "8_24", "9_24", "10_24", "11_24", "12_24", "13_24", "14_24", "15_24", "16_24", "17_24", "18_24" ],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "9_24" ],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "10_24", "11_24" ],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16" ],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "10_24", "11_24", "12_24"],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12" ],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14" ],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11" ],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18" ],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35" ],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16" ],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15" ],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "100", "101", "102", "103", "104", "105", "106", "107", "108", "109" ],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10_24" ],
    ],

    ///////////////////////////////////////////////////////////
    //全景点位图标
    panospot: [
		[],
        [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "1_24", "2_24", "3_24", "4_24", "6_24", "14_24", "15_24", "16_24" ],
    ]
}

const path	 = '/images/';

//根据参数生成图标分组
function groups(type){
	return GROUPS[type];
}

function getItem(type, group, index, v){
	let a = v.split('_');
	return {
		frame	: a.length >1 ? parseInt(a[1]) : 1,
		group	: group,
		index	: index,
		url		: path + type + '/' + group + '/' + v + '.png',
	}
}

//根据参数生成图标列表
function icons(type, group, filter){
	const result = [];
	
	if(type && group){
		ICONS[type][group].forEach((v,i,arr)=>{
			let item = getItem(type, group, i, v);
			if(!filter 
			|| (filter==1 && item.frame==1) 
			|| (filter==2 && item.frame>1)) result.push(item);
		});
	} else if(type){
		ICONS[type].forEach((group, idx)=>{
			group.forEach((v,i,arr)=>{
				let item = getItem(type, idx, i, v);
				if(!filter 
				|| (filter==1 && item.frame==1) 
				|| (filter==2 && item.frame>1)) result.push(item);
			});
		});
	} else {
		for(let key in ICONS){
			ICONS[key].forEach((group, idx)=>{
				group.forEach((v,i,arr)=>{
					let item = getItem(type, idx, i, v);
					if(!filter 
					|| (filter==1 && item.frame==1) 
					|| (filter==2 && item.frame>1)) result.push(item);
				});
			});
		}
	}
	
	return result;
}

function parse(url){
	if(!url || !url.length) url = '/images/panospot/1/1.png';
	if(url.substr(0,1) != '/') url = '/' + url;
	
	let arr		= url.substr(url.indexOf('/images/')).split('/');
	let count	= arr.length;
	let type	= arr[2];
	let group	= arr[3];
	let file	= arr[4].split('.')[0];
	let index	= 0;
	let icons	= ICONS[type][group];
	
	for(let i=0; i<icons.length; i++){
		if(icons[i] == file) {
			index = i;
			break;
		}
	}

	return {
		type,
		group,
		index,
		file,
		url,
	}
}


export default {
	icons,
	groups,
	parse,
}